import { getElectronSmsNotificationContext } from "./electron/electronSmsNotificationContext";

/** Max body length for native desktop SMS notifications (OS tray/display limits). */
export const DESKTOP_SMS_NOTIFICATION_BODY_MAX_LENGTH = 140;

type IncomingSmsMessage = {
  id: string;
  did: string;
  participant: string;
  conversation_id: string;
  conversation_participants?: string[];
  conversation_type?: "direct" | "group";
  body?: string;
};

export function maybeNotifyIncomingSmsDesktop(
  msg: IncomingSmsMessage,
  title: string
): void {
  const api = window.electronAPI;
  if (!api?.notifyIncomingSms) return;

  const gating = getElectronSmsNotificationContext();
  if (
    document.visibilityState === "visible" &&
    document.hasFocus() &&
    gating.activeDid === msg.did &&
    gating.activeConversationId === msg.conversation_id
  ) {
    return;
  }

  const preview = (msg.body ?? "").trim() || "New message";
  const maxLength = DESKTOP_SMS_NOTIFICATION_BODY_MAX_LENGTH;
  const participants = msg.conversation_participants?.length
    ? msg.conversation_participants
    : [msg.participant];

  api.notifyIncomingSms({
    messageId: msg.id,
    title,
    body:
      preview.length > maxLength
        ? `${preview.slice(0, maxLength - 3)}…`
        : preview,
    did: msg.did,
    conversationId: msg.conversation_id,
    participants,
    type: msg.conversation_type || (participants.length > 1 ? "group" : "direct"),
  });
}
